import React, { useState, useEffect } from 'react'
import { navigate } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import { Container } from '../../../Container'
import ContentfulLongText from '../../../ContentfulLongText'
import { WholeBackground } from './WholeBackground'
import { ArrowLeft, ArrowRight } from '../../../Arrow'

export const SectionMain = ({
    item,
    index,
    language,
    handleLanguageChange,
    filteredData,
    visibleItems,
    visibleAllBlogItems,
    visibleVideoItems,
    loadMoreVideos,
    datas,
    mainAllLoadMore,
    loadMore
}) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [itemsPerSlide, setItemsPerSlide] = useState(2);

    const totalSlides = Math.ceil(item.mainVideos?.length / itemsPerSlide);

    const handleNextSlide = () => {
        if (currentSlide < totalSlides - 1) {
            setCurrentSlide(currentSlide + 1);
        }
    };

    const handlePrevSlide = () => {
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    };

    useEffect(() => {
        const updateItemsPerSlide = () => {
            if (window.innerWidth <= 768) {
                setItemsPerSlide(1);
            } else {
                setItemsPerSlide(2);
            }
        };

        updateItemsPerSlide();
        window.addEventListener('resize', updateItemsPerSlide);

        return () => {
            window.removeEventListener('resize', updateItemsPerSlide);
        };
    }, []);

    return (
        <div className="relative main">
            <Container>
                <WholeBackground
                    item={item}
                    index={index}
                    language={language}
                    handleLanguageChange={handleLanguageChange}
                />
                {item.showTheLatestPosts ? (
                    <div className='all-blogs'>
                        <div className={`grid col-${item.mainColumnCount} col-1-md col-2-lg gap-40`}>
                            {filteredData.slice(0, visibleAllBlogItems[index]).map((item, index)=>(
                                <div key={index} className={`item ${item.mainColumnCount === '1' ? 'grid col-3-6 col-1-md gap-15 col-1-lg align-center' : ''} ${item.mainColumnCount === '2' ? 'grid col-6-5 col-1-md gap-15 col-1-lg align-center main-column-2' : ''}`}>
                                    <div className='img'>
                                        <a className="button-hyperlink relative block main-img cursor-pointer" href={`/${item.parentCategory.slugId}/${item.blogPostUrlSlug}/`}>
                                            <img className="absolute top-0 left-0 right-0 bottom-0" src={item.thumbnailImage.gatsbyImageData.images.fallback.src} alt='Categories' />
                                        </a>
                                        <p className="mt-5 mb-5 bold lists-category">{item.parentCategory.categoryName}</p>
                                    </div>
                                    <div className='main-content'>
                                        <a href={`/${item.parentCategory.slugId}/${item.blogPostUrlSlug}/`} className='button-hyperlink cursor-pointer'>{item.title}</a>
                                        {documentToReactComponents(JSON.parse(item.excerpt.raw))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ):(    
                    <div className={`grid col-${item.mainVideos ? 1 : item.mainColumnCount} col-1-md col-2-lg gap-40`}>
                        {item.mainVideos ? (
                            <div className="relative w-full blog-main-videos">
                                <div className="grid col-2 col-1-sm gap-30 w-full slider-container">
                                    {item.mainVideos?.slice(currentSlide * itemsPerSlide, (currentSlide + 1) * itemsPerSlide).map((mainVideoItem, mainVideoIndex) => {
                                        const videoId = mainVideoItem.media && mainVideoItem.media.match(/(?:\/|%2F)([A-Za-z0-9_-]{11})/)?.[1];
                                        const youtubeEmbedLink = videoId ? `https://www.youtube.com/embed/${videoId}` : null;

                                        return youtubeEmbedLink ? (
                                            <div key={mainVideoIndex} className="item main-videos">
                                                <div className='img'>
                                                    <div className="relative main-img cursor-pointer">
                                                        <iframe
                                                            src={youtubeEmbedLink}
                                                            title={mainVideoItem.title}
                                                            frameBorder="0"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                            allowFullScreen
                                                        ></iframe>
                                                    </div>
                                                </div>
                                                <div className='main-content'>
                                                    <a href={mainVideoItem.link} className='block button-hyperlink mt-10 text-default cursor-pointer'>{mainVideoItem.title}</a>
                                                    <ContentfulLongText longTextContent={mainVideoItem.content.content} classNameProp='white-space-inherit' />
                                                </div>
                                            </div>
                                        ) : null;
                                    })}
                                </div>
                                <div className="slider-controls">
                                    <button className={`btn--plain btn--left cursor-pointer absolute top-50pct left-0 z-2${currentSlide === 0 ? ' button-transparent-30':''}`} onClick={handlePrevSlide} disabled={currentSlide === 0}><ArrowLeft /></button>
                                    <button className={`btn--plain btn--right cursor-pointer absolute top-50pct right-0 z-2${currentSlide === totalSlides - 1 ? ' button-transparent-30':''}`} onClick={handleNextSlide} disabled={currentSlide === totalSlides - 1}><ArrowRight /></button>
                                </div>
                            </div>
                        ):item.mainBlogs.slice(0, visibleItems[index]).map((mainItem, mainIndex) => (
                            <div key={mainIndex} className={`item ${item.mainColumnCount === '1' ? 'grid col-3-6 col-1-md gap-15 col-1-lg align-center' : ''} ${item.mainColumnCount === '2' ? 'grid col-6-5 col-1-md gap-15 col-1-lg main-column-2' : ''}`}>
                                <div className='img'>
                                    <a className="block relative main-img button-hyperlink cursor-pointer" href={`/${mainItem.parentCategory.slugId}/${mainItem.blogPostUrlSlug}/`}>
                                        <img className="absolute top-0 left-0 right-0 bottom-0" src={mainItem.thumbnailImage.gatsbyImageData.images.fallback.src} alt='Categories' />
                                    </a>
                                    <p className="mt-5 mb-5 bold lists-category">{mainItem.parentCategory.categoryName}</p>
                                </div>
                                <div className='main-content'>
                                    <a href={`/${mainItem.parentCategory.slugId}/${mainItem.blogPostUrlSlug}/`} className='block button-hyperlink mt-10 text-default cursor-pointer'>{mainItem.title}</a>
                                    {documentToReactComponents(JSON.parse(mainItem.excerpt.raw))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {item.mainVideos ? visibleVideoItems[index] < item.mainVideos.length && (
                    <div className="w-full flex justify-center text-center load-more-container">
                        <button onClick={() => loadMoreVideos(index)} className="btn-linear load-more-button">
                            Load More
                        </button>
                    </div>
                ):item.showTheLatestPosts ? visibleAllBlogItems[index] < datas.length && (
                    <div className="w-full flex justify-center text-center load-more-container">
                        <button onClick={() => mainAllLoadMore(index)} className="btn-linear load-more-button">
                            Load More
                        </button>
                    </div>
                ): visibleItems[index] < item.mainBlogs.length && (
                    <div className="w-full flex justify-center text-center load-more-container">
                        <button onClick={() => loadMore(index)} className="btn-linear load-more-button">
                            Load More
                        </button>
                    </div>
                )}
            </Container>
        </div>
    )
}